import { createAction, props } from '@ngrx/store';

// reducer actions
export const setContext = createAction('[Context] SET CONTEXT', props<{ context: string }>());

// effects actions
export const setContextEffect = createAction('[Context] SET CONTEXT EFFECT', props<{ ids: string[] }>());
